// extracted by mini-css-extract-plugin
export var center = "_4f-2";
export var clickableRow = "_4f-5";
export var expandedRow = "_4f-7";
export var hoverable = "_4f-4";
export var left = "_4f-1";
export var right = "_4f-3";
export var row = "_4f-0";
export var selectedRow = "_4f-6";
export var summaryRow = "_4f-8";